
import { Component, Prop, Provide, Vue } from 'vue-property-decorator'

@Component
export default class Dialog extends Vue {
    visible = {
        val: false
    }
    @Provide('visible')
    visibleVal = this.visible
    // props
    @Prop({ default: '' }) title!: string //ชื่อหน้าต่างป๊อปอัป
    @Prop({ default: 'ยืนยันการลบ？' }) content!: string //เนื้อหาป๊อปอัป
    @Prop({ default: 'ยืนยัน' }) confirmButtonText!: string //ยืนยัน按钮内容
    @Prop({ default: 'ยกเลิก' }) cancelButtonText!: string | boolean //ยกเลิก按钮内容
    @Prop({ default: '400px' }) width!: string | number //ความกว้างของหน้าต่างป๊อปอัป
    @Prop({ default: '40vh' }) top!: string | number //ระยะห่างจากด้านบนของหน้าต่างป๊อปอัป
    @Prop({ default: false }) disabled!: boolean //ไม่ว่าจะปิดการใช้งาน
    @Prop({ default: false }) async!: boolean //ไม่ว่าจะเปิดใช้งานการปิดระบบแบบอะซิงโครนัสหรือไม่
    @Prop({ default: true }) clickModalClose!: boolean // คลิกที่เลเยอร์มาสก์เพื่อปิดหน้าต่างข้อความ
    // data
    
    // methods
    handleEvent(type: 'cancel' | 'confirm') {
        this.$emit(type)
        if (!this.async || type === 'cancel') this.close()
    }

    onTrigger() {
        if (this.disabled) return
        this.open()
    }

    close() {
        this.visible.val = false
        this.$emit('close')
    }
    open() {
        this.visible.val = true
        this.$emit('open')
    }
}
